<template>
    <router-link
        v-if="target === '_self'"
        :to="href"
        :aria-label="label"
        :class="[classes, { active: isActive }]"
    >
        <span v-html="getLabel"></span>
        <CaretRight v-if="addCaret" />
    </router-link>
    <a v-else :class="[classes, { active: isActive }]" :href="href" :target="target" :aria-label="label" >
        <span v-html="getLabel"></span>
        <CaretRight v-if="addCaret" />
    </a>
</template>

<script>
import CaretRight from "@/components/svgs/CaretRight.vue";
export default {
    name: "LinkComponent",
    components: {
        CaretRight,
    },
    props: {
        href: {
            type: String,
            required: true,
            default: '',
        },
        target: {
            type: String,
            required: true,
            default: '',
        },
        label: {
            type: String,
            required: true,
            default: '',
        },
        classes: {
            type: String,
            required: false,
            default: '',
        },
        isButton: {
            type: Boolean,
            required: false,
            default: false,
        },
        addCaret: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    computed: {
        isActive() {
            return this.href === this.$route.path;
        },
        getLabel() {
            if (this.isButton) {
                return `<button class="btn"><span>${this.label}</span></button>`;
            } else {
                return this.label;
            }
        }
    }
}
</script>
